import { SelectDestinationFolderModal } from "@/components/features/matter/file-repo/signature-requests/SelectDestinationFolderModal";
import type { MassTort, Matter, MatterFile } from "@/lib/types";
import { useMemo } from "react";

interface SelectDestinationFolderSlideoverProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  matter?: Matter;
  massTort?: MassTort;
  initialFolderId?: string;
  onFolderSelected: (folder: MatterFile | null) => void;
  title?: string;
  description?: string;
  overlayClassName?: string;
  className?: string;
}

export const SelectDestinationFolderSlideover = ({
  open,
  setOpen,
  matter,
  massTort,
  initialFolderId = "",
  onFolderSelected,
  title = "Select destination folder",
  description = "Choose a folder where the signed document will be stored",
  overlayClassName,
  className,
}: SelectDestinationFolderSlideoverProps) => {
  const matterFiles = useMemo(
    () => matter?.files ?? massTort?.files ?? [],
    [massTort?.files, matter?.files],
  );

  const handleFolderSelected = (folderId: string) => {
    if (!folderId) {
      onFolderSelected(null);
      return;
    }

    const folder = matterFiles.find(
      (item) => item.id === folderId && item.isFolder,
    );

    if (!folder) {
      onFolderSelected(null);
      return;
    }

    onFolderSelected({
      ...folder,
      matterId: folder.matterId ?? matter?.id ?? massTort?.id ?? "",
      idLocation: folder.idLocation ?? "",
      presignedUrlKey: folder.presignedUrlKey ?? undefined,
      variables: folder.variables ?? undefined,
    } as MatterFile);
  };

  if (matter) {
    return (
      <SelectDestinationFolderModal
        open={open}
        setOpen={setOpen}
        matter={matter}
        initialFolderId={initialFolderId}
        onFolderSelected={handleFolderSelected}
        title={title}
        description={description}
        overlayClassName={overlayClassName}
        className={className}
      />
    );
  }

  if (massTort) {
    return (
      <SelectDestinationFolderModal
        open={open}
        setOpen={setOpen}
        massTort={massTort}
        initialFolderId={initialFolderId}
        onFolderSelected={handleFolderSelected}
        title={title}
        description={description}
        overlayClassName={overlayClassName}
        className={className}
      />
    );
  }

  return null;
};
